import { Injectable } from '@angular/core';
import { MetaPixelEvent } from 'src/app/core/enums/metaPixelEvent.enum';

const SCRIPT_ID = 'meta-pixel';
const NOSCRIPT_ID = 'meta-pixel-noscript';

@Injectable({
  providedIn: 'root',
})
export class MetaPixelService {
  insertScript(pixelId: string, track: MetaPixelEvent) {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;

    script.innerHTML = `
        !function(f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function() {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = true;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = true;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

        fbq('init', '${pixelId}');
        fbq('track', '${track}');
    `;

    const noscript = document.createElement('noscript');
    noscript.id = NOSCRIPT_ID;
    noscript.innerHTML = `<img height="1" width="1" style="display:none"          src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"/>`;

    document.head.appendChild(noscript);
    document.head.appendChild(script);
  }

  removeScript() {
    const script = document.getElementById(SCRIPT_ID);
    script?.remove();

    const noscript = document.getElementById(NOSCRIPT_ID);
    noscript?.remove();
  }
}
